import moment from "moment";

const SingleBlogHeader = ({ blogData }) => {
  return (
    <div className="pt-4">
      {/* {blogData?.label?.map((label, index) => (
        <span
          key={index}
          className="bg-lightRed py-2 px-3 text-white mr-2 rounded-md"
        >
          {label}
        </span>
      ))} */}
      <h1 className="my-4 sm:text-4xl text-2xl font-bold font-Inconsolata">
        {blogData?.content?.title}
      </h1>
      <div
        className=" tracking-[0.1] text-[#00000096] text-md font-medium font-Outfit"
        dangerouslySetInnerHTML={{ __html: blogData?.content?.subheading }}
      />
      <span className="text-sm text-black opacity-60 py-4 block font-Outfit">
        <span className="block pr-2">By Admin</span>
        <span>
          Last updated {moment(blogData?.createdDate).format("MMM DD, YYYY")}
        </span>
      </span>
    </div>
  );
};

export default SingleBlogHeader;
